import { NavLink } from "react-router-dom";
import "./Sidebar.css";
import logo from "../../../../assets/img/topbar/logo.png";

const Sidebar = ({ isOpen, closeSidebar, isCollapsed = false }) => {
  return (
    <div
      className={`sidebar ${isOpen ? "open" : ""} ${isCollapsed ? "collapsed" : ""}`}
    >
      <div className="logo-container">
        <div className="text-center py-3">
          <img src={logo} alt="Logo" className="logo-img" />
        </div>
        <button className="close-sidebar" onClick={closeSidebar}>
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
      <nav className="sidebar-nav">
        <NavLink
          to="/organization/dashboard"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-house-door"></i>
          <span>Home</span>
        </NavLink>
        <NavLink
          to="/organization/school"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-house-door"></i>
          <span>School</span>
        </NavLink>
        <NavLink
          to="/organization/license/assign"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-grid"></i>
          <span>License</span>
        </NavLink>
        <NavLink
          to="/organization/notification"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-bell"></i>
          <span>Notification</span>
        </NavLink>
        <NavLink
          to="/organization/settings"
          className={({ isActive }) =>
            `sidebar-link ${isActive ? "active" : ""}`
          }
          onClick={closeSidebar}
        >
          <i className="bi bi-gear"></i>
          <span>Settings</span>
        </NavLink>
        {/* <NavLink */}
        {/*   to="/organization/settings" */}
        {/*   className={({ isActive }) => */}
        {/*     `sidebar-link ${isActive ? "active" : ""}` */}
        {/*   } */}
        {/*   onClick={closeSidebar} */}
        {/* > */}
        {/*   <i className="bi bi-gear"></i> */}
        {/*   <span>Settings</span> */}
        {/* </NavLink> */}
      </nav>
    </div>
  );
};

export default Sidebar;
